// - image loader

const Util = () => {};
Util.prototype = {
  readURL: (input) => {
    if (input.files && input.files[0]) {
      const reader = new FileReader();
      reader.onload = (e) => {
        $('#imgShow').attr('src', e.target.result);
      };
      reader.readAsDataURL(input.files[0]);
    }
  },
  sampleOverlay: () => {
    const $overlay = $('.overlay-milesSample');
    $('.sample-link').click(() => {
      $overlay.fadeIn();
    });
    $overlay.click(function () {
      $(this).fadeOut();
    });
  },
  checkInputNumber: (dom, meassage, type) => {
    const checkNumber = number => (/^[0-9]*$/.test(number));
    const checkPhone = phone => (/^1[34578]\d{9}$/.test(phone));
    const checkFrame = frame => (/^(\d{8})$/).test(frame);
    $(dom).focus(function () {
      const _this = $(this);
      if (_this.val() === _this.attr('name') || _this.hasClass('error')) {
        _this.removeClass('error').val('');
      }
    }).blur(function () {
      const _this = $(this);
      const _val = _this.val();
      if (_this.val() === '') {
        _this.val(_this.attr('name'));
      } else if (_val !== _this.attr('name') && _val !== _this.attr('data-error')) {
        if (type === 'num') {
          if (!checkNumber(_this.val())) {
            _this.addClass('error').val(meassage);
          }
        }
        if (type === 'phone') {
          if (!checkPhone(_this.val())) {
            _this.addClass('error').val(meassage);
          }
        }
        if (type === 'frame') {
          if (!checkFrame(_this.val())) {
            _this.addClass('error').val(meassage);
          }
        }
      }
    });
  },
  checkInputName: (dom, message) => {
    $(dom).focus(function () {
      const _this = $(this);
      if (_this.val() === _this.attr('name') || _this.hasClass('error')) {
        _this.removeClass('error').val('');
      }
    }).blur(function () {
      const _this = $(this);
      if (_this.val() === '') {
        // _this.val(_this.attr('name'));
        _this.addClass('error').val(message);
      }
    });
  },
};
const util = new Util();
export default util;



// WEBPACK FOOTER //
// src/components/helper-modules/util.jsx